/**
 * Instafeed homepage tweaks:
 * - Disable auto-scroll; keep manual swipe/drag
 * - Skip full feed rebuild on resize within the same breakpoint (prevents flash)
 * - Breakpoint: mobile ≤1029px, desktop ≥1030px (matches EA theme contract)
 */
(function () {
  if (window.__eaInstafeedManualInit) return;
  window.__eaInstafeedManualInit = true;

  const nativeSetInterval = window.setInterval.bind(window);

  function isInstafeedAutoplayInterval(handler) {
    if (typeof handler !== 'function') return false;
    const source = handler.toString();
    return source.includes('InstafeedAPI.sliderMove') || source.includes('sliderMove(');
  }

  window.setInterval = function (handler, timeout, ...args) {
    if (isInstafeedAutoplayInterval(handler)) {
      return -1;
    }
    return nativeSetInterval(handler, timeout, ...args);
  };

  function clearInstafeedAutoplay() {
    const intervals = window.instafeedScrollIntervals;
    if (!intervals) return;

    Object.keys(intervals).forEach((feedId) => {
      clearInterval(intervals[feedId]);
      delete intervals[feedId];
    });
  }

  function getInstafeedBreakpoint(width) {
    return width <= 1029 ? 'mobile' : 'desktop';
  }

  function feedNeedsRebuild() {
    const feed = document.querySelector('#insta-feed');
    return !feed?.querySelector('.instafeed-new-layout-container');
  }

  function patchInstafeedApp() {
    if (typeof window.instafeedApp !== 'function' || window.instafeedApp.__eaPatched) {
      return false;
    }

    const nativeApp = window.instafeedApp;
    let lastBreakpoint = getInstafeedBreakpoint(window.innerWidth);

    window.instafeedApp = function eaInstafeedApp() {
      const nextBreakpoint = getInstafeedBreakpoint(window.innerWidth);

      if (!feedNeedsRebuild() && nextBreakpoint === lastBreakpoint) {
        return;
      }

      lastBreakpoint = nextBreakpoint;
      return nativeApp();
    };

    window.instafeedApp.__eaPatched = true;
    return true;
  }

  let isNormalizing = false;

  /** Instafeed inline flex/% widths collapse the track — layout is driven by theme CSS (cqw). */
  function normalizeInstafeedLayout(feedRoot) {
    if (isNormalizing) return;

    const items = feedRoot.querySelectorAll('.instafeed-new-layout-item');
    if (items.length === 0) return;

    isNormalizing = true;

    feedRoot.style.removeProperty('overflow');
    feedRoot.style.removeProperty('width');

    const appBlock = feedRoot.closest('.shopify-app-block');
    if (appBlock) {
      appBlock.style.removeProperty('overflow');
      appBlock.style.removeProperty('width');
    }

    feedRoot.querySelectorAll('.instafeed-new-layout-container').forEach((container) => {
      container.style.removeProperty('width');
      container.style.removeProperty('height');
      container.style.removeProperty('overflow');
    });

    feedRoot.querySelectorAll('.instafeed-new-layout-wrapper').forEach((wrapper) => {
      wrapper.style.removeProperty('gap');
    });

    feedRoot.querySelectorAll('.instafeed-new-layout-item').forEach((item) => {
      item.style.removeProperty('width');
      item.style.removeProperty('height');
      item.style.removeProperty('clip-path');
    });

    ensureInstafeedScrollIndicator(feedRoot);

    isNormalizing = false;
  }

  function ensureInstafeedScrollIndicator(feedRoot) {
    const container = feedRoot.querySelector('.instafeed-new-layout-container');
    if (!container) return;

    const host = container.parentElement;
    if (!host) return;

    let indicator = host.querySelector('ea-horizontal-scroll-indicator[data-insta-feed]');

    if (!indicator) {
      indicator = document.createElement('ea-horizontal-scroll-indicator');
      indicator.className = 'ea-horizontal-scroll-indicator';
      indicator.dataset.instaFeed = 'true';
      indicator.dataset.target = '.instafeed-new-layout-container';
      indicator.hidden = true;
      indicator.innerHTML =
        '<span class="ea-horizontal-scroll-indicator__track" aria-hidden="true"><span class="ea-horizontal-scroll-indicator__thumb"></span></span>';
      host.appendChild(indicator);
    }
  }

  let normalizeFrame = null;

  function scheduleNormalize(feedRoot) {
    if (normalizeFrame) cancelAnimationFrame(normalizeFrame);
    normalizeFrame = requestAnimationFrame(() => {
      normalizeFrame = null;
      normalizeInstafeedLayout(feedRoot);
    });
  }

  function initWhenFeedReady() {
    const feedRoot = document.querySelector('#insta-feed');
    if (!feedRoot) return;

    clearInstafeedAutoplay();
    patchInstafeedApp();
    scheduleNormalize(feedRoot);

    if (feedRoot.dataset.eaInstafeedObserved) return;
    feedRoot.dataset.eaInstafeedObserved = 'true';

    const observer = new MutationObserver(() => {
      clearInstafeedAutoplay();
      patchInstafeedApp();
      scheduleNormalize(feedRoot);
    });

    observer.observe(feedRoot, { childList: true, subtree: true });
  }

  function waitForInstafeed() {
    initWhenFeedReady();

    if (!window.instafeedApp?.__eaPatched) {
      requestAnimationFrame(waitForInstafeed);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForInstafeed);
  } else {
    waitForInstafeed();
  }
})();
